import $ from "jquery";

const handleSendPostData = (printPdfUrlSelector, isBlank = false) => {
  $(document).on("click", printPdfUrlSelector, function () {
    const form = document.createElement("form");
    form.method = "POST";
    if (isBlank) {
      form.target = "_blank";
    }
    form.action = $(this).data("form_action"); // Replace with the actual URL

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "data";
    input.value = $(this).find("input").val();
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
  });
};

export default handleSendPostData;
